<form [formGroup]="voucherForm" (ngSubmit)="saveVoucher(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-coupon-line me-1 font-20 text-primary"></i>{{voucherForm.value.id?'Update':'Add'}} Voucher
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-6">
        <label for="date" class="form-label"> Date <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
              class='bx bx-calendar'></i></span>
          <input type="date" class="form-control ps-1" id="date" formControlName="date" ngbAutofocus
            [ngClass]="{'is-invalid': submitted && v.date.errors}" />
          <div class="invalid-feedback" *ngIf="submitted && v.date.errors">
            <span *ngIf="v.date.errors.required">Please select a date.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label for="voucherType" class="form-label"> Voucher Type <b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="voucherType" placeholder="Select voucher type"
            [ngClass]="{'is-invalid': submitted && v.voucherType.errors}" [clearable]="false">
            <ng-option *ngFor=" let type of voucherTypes;" [value]="type">{{type}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && v.voucherType.errors">
            <span *ngIf="v.voucherType.errors.required">Please select a voucher type.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="voucherNo" class="form-label">Voucher Number</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='ri-secure-payment-fill'></i></span>
          <input type="text" class="form-control ps-1" id="voucherNo" formControlName="voucherNo" readonly
            placeholder="Voucher number" autocomplete="off" />
        </div>
      </div>
      <div class="col-md-3">
        <label for="invoiceNo" class="form-label">Invoice Number</label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='ri-invision-line'></i></span>
          <input type="text" class="form-control ps-1" id="invoiceNo" formControlName="invoiceNo"
            placeholder="Enter Invoice..." autocomplete="off" />
        </div>
      </div>
      <div class="col-md-6">
        <label for="narration" class="form-label">Narration <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
              class='ri-paragraph'></i></span>
          <textarea cols="1" rows="1" type="text" class="form-control ps-1" id="narration" formControlName="narration"
            placeholder="Enter the narration" [ngClass]="{'is-invalid': submitted && v.narration.errors}"></textarea>
          <div class="invalid-feedback" *ngIf="submitted && v.narration.errors">
            <span *ngIf="v.narration.errors.required">Please enter narration.</span>
          </div>
        </div>
      </div>
      <div class="col-md-6"
        *ngIf="voucherForm.get('voucherType')?.value === 'PURCHASE' || voucherForm.get('voucherType')?.value === 'SALES'">
        <label for="byStateCode" class="form-label">By State Code <b class="text-secondary">*</b></label>
        <input type="text" class="form-control" formControlName="byStateCode" placeholder="Enter the By State Code"
          [ngClass]="{'is-invalid': submitted && v.byStateCode.errors}" />
        <div class="invalid-feedback" *ngIf="submitted && v.byStateCode.errors">
          <span *ngIf="v.byStateCode.errors.required">Please enter a state code</span>
          <span *ngIf="v.byStateCode.errors.pattern">State Code must be a valid code (e.g., AP, AR, AS, BR, etc.)</span>
        </div>
      </div>
      <div class="col-md-6"
        *ngIf="voucherForm.get('voucherType')?.value === 'PURCHASE' || voucherForm.get('voucherType')?.value === 'SALES'">
        <label for="toStateCode" class="form-label">To State Code <b class="text-secondary">*</b></label>
        <input type="text" class="form-control" formControlName="toStateCode" placeholder="Enter the To State Code"
          [ngClass]="{'is-invalid': submitted && v.toStateCode.errors}" />
        <div class="invalid-feedback" *ngIf="submitted && v.toStateCode.errors">
          <span *ngIf="v.toStateCode.errors.required">Please enter a valid statecode</span>
          <span *ngIf="v.toStateCode.errors.pattern">State Code must be a valid code (e.g., AP, AR, AS, BR, etc.)</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer  border-0">
    <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"
      [hidden]="voucherForm.value.voucherStatus === 'POSTED'"><i class="bx bx-x"></i>Close</button>
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}"
      [hidden]="voucherForm.value.voucherStatus === 'POSTED'">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{voucherForm.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>{{voucherForm.value.id?'Save Changes':'Save'}}
      </ng-container>
    </button>
  </div>
</form>
<section class="rcx-table" style="border-top: 2px dotted var(--bs-primary);" *ngIf="voucherForm.value.id">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class='ri-pantone-line me-1 text-primary'></i>Voucher Entries
                </h5>
              </div>
              <div class="col-sm-12 col-md-auto ms-auto me-2 text-center border-dotted"
                [hidden]="voucherForm.value.voucherStatus === 'POSTED'">
                <button type="button" id="save-btn" class="border-dotted-btn">
                  <span class="text-primary mb-2" (click)="upsertVoucherEntry()">
                    <i class="bx bx-plus"></i>Apply Voucher</span>
                </button>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="300">Account Type</th>
                  <th scope="col" width="300">Account Name</th>
                  <th scope="col" width="300">Particular</th>
                  <th scope="col" width="300">Debit</th>
                  <th scope="col" width="300">Credit</th>
                  <th scope="col" width="160" class="text-center"
                    [hidden]="voucherForm.value.voucherStatus === 'POSTED'">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let voucherEntry of voucherEntries; let i=index">
                  <td>{{ voucherEntry.byAccount ? 'byAccount' : 'toAccount' }}</td>
                  <td>{{voucherEntry.accountName}}</td>
                  <td>{{voucherEntry.particular}}</td>
                  <td>{{ voucherEntry.byAccount ? voucherEntry.amount : '-' }}</td>
                  <td>{{ voucherEntry.credit ? voucherEntry.amount : '-'}}</td>
                  <td class="actions" [hidden]="voucherForm.value.voucherStatus === 'POSTED'">
                    <i class="bx bx-edit alert-primary" ngbTooltip="Edit"
                      (click)="upsertVoucherEntry(voucherEntry)"></i>
                    <input type="file" #fileInputElement style="display: none;"
                      (change)="onFileSelected($event, voucherEntry.id)">
                    <i class="ri-file-upload-line alert-primary" id="upload-btn" ngbTooltip="Upload file"
                      (click)="triggerFileInput(fileInputElement)">
                    </i>
                  </td>
                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="6">No voucher entries were found.</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="transactionEntries && transactionEntries.length < 1; else noSearchResults">
                      <td colspan="6">No voucher entries were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="6"
                        *ngIf="searchKeyword && (transactionEntries | search : 'name' : searchKeyword).length == 0">
                        No voucher entries were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>